import React from 'react';
import PricePlan from '../../components/Other Pages/PricePlanExample/PricePlan';

function PricePlanExample (){
        return(
            <PricePlan/>
        )
    }
export default PricePlanExample;